interface ValuesListProps {
  items: string[];
}

export default function ValuesList({ items }: ValuesListProps) {
  if (items.length === 0) {
    return (
      <div className="rounded-md border bg-card px-3 py-6 text-center text-xs text-muted-foreground">
        No values.
      </div>
    );
  }

  return (
    <div className="rounded-md border bg-card overflow-hidden">
      <div className="max-h-64 overflow-y-auto">
        <ol className="divide-y">
          {items.map((v, i) => (
            // minmax(0, 1fr) overrides the grid item's default
            // `min-width: auto` (= min-content). Without that, a long
            // unbreakable item — including the parseCollection
            // fallback case where the whole decoded YAML payload is
            // emitted as a single string — sets a high min-content
            // and stretches the 1fr track wider than its share,
            // pushing this whole list (and its parent <td colSpan={5}>)
            // beyond the outer table's available width. min-w-0 on
            // the <pre> belt-and-braces that for browsers / content
            // combinations where break-all alone doesn't drop
            // min-content to 1ch.
            <li
              key={i}
              className="grid grid-cols-[2.5rem_minmax(0,1fr)] gap-2 px-3 py-1.5 text-xs"
            >
              <span className="text-muted-foreground font-mono text-right">
                {i + 1}.
              </span>
              <pre className="min-w-0 whitespace-pre-wrap break-all font-mono">
                {v}
              </pre>
            </li>
          ))}
        </ol>
      </div>
      <div className="border-t bg-muted/20 px-3 py-1 text-[11px] text-muted-foreground">
        {items.length} item{items.length === 1 ? '' : 's'}
      </div>
    </div>
  );
}
